import { prependBackendAPIHost } from "repoV2/utils/common/api/api";

export const USER_DETAILS_APIS = {
    GENERATE_OTP_FOR_ACCOUNT_DETAILS_UPDATE: prependBackendAPIHost(
        "payments/generate/generic/otp"
    ),
    VERIFY_OTP_FOR_ACCOUNT_DETAILS_UPDATE: prependBackendAPIHost(
        "payments/verify/generic/otp"
    ),
};
export const OTP_PURPOSE = {
    details_verifications: 2,
    auth_actions: 1,
    creator_email_updation: 3,
    creator_phone_number_updation: 4,
};
